import { useState } from 'react';
import axios from 'axios';

export default function Registro() {
  const [formData, setFormData] = useState({
    nombreCompleto: '',
    email: '',
    contraseña: '',
    edad: '',
    peso: '',
    altura: '',
    fase: '',
  });

  // 👇 handleChange con tipo para inputs y select
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // 👇 handleSubmit con tipo para evento de formulario
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      await axios.post('http://localhost:3001/api/usuarios', formData);
      alert('Rutina enviada por correo 📩');
    } catch (error) {
      console.error(error);
      alert('Hubo un error al enviar la rutina 😔');
    }
  };

  return (
    <div className="p-4 max-w-lg mx-auto">
      <h2 className="text-xl font-bold mb-4">Registro de rutina por fase</h2>
      <form onSubmit={handleSubmit} className="space-y-3">
        <input
          type="text"
          name="nombreCompleto"
          onChange={handleChange}
          placeholder="Nombre completo"
          required
          className="input"
        />
        <input
          type="email"
          name="email"
          onChange={handleChange}
          placeholder="Email"
          required
          className="input"
        />
        <input
          type="password"
          name="contraseña"
          onChange={handleChange}
          placeholder="Contraseña"
          required
          className="input"
        />
        <input
          type="number"
          name="edad"
          onChange={handleChange}
          placeholder="Edad"
          required
          className="input"
        />
        <input
          type="number"
          name="peso"
          onChange={handleChange}
          placeholder="Peso (kg)"
          required
          className="input"
        />
        <input
          type="number"
          name="altura"
          onChange={handleChange}
          placeholder="Altura (cm)"
          required
          className="input"
        />
        <select name="fase" onChange={handleChange} required className="input">
          <option value="">Seleccioná tu fase</option>
          <option value="palestra">Palestra</option>
          <option value="calistenia-principiante">Principiante</option>
          <option value="calistenia-intermedio">Intermedio</option>
          <option value="calistenia-avanzado">Avanzado</option>
        </select>
        <button type="submit" className="btn">Enviar rutina</button>
      </form>
    </div>
  );
}
